import { UseFormReturn } from 'react-hook-form'
import { RecognitionErrorsResponse } from '~/shared/api'
import { Form } from './ui/Form'
import { FormValues } from './ui/model'

type CorrectionStepProps = {
  onSuccess: (formValues: FormValues) => void
  form: UseFormReturn<FormValues>
  errorsData?: RecognitionErrorsResponse | null
  isLoading?: boolean
}

export function CorrectionStep({
  onSuccess,
  form,
  errorsData,
  isLoading,
}: CorrectionStepProps) {
  return (
    <Form
      onSuccess={onSuccess}
      form={form}
      errorsData={errorsData}
      isLoading={isLoading}
    />
  )
}
